import $ from 'jquery';
import { estimatedFCP, now } from '../../util/system.js';

/**
 * Honeypot handling
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	for (const element of $collection) {
		const $element = $(element);
		const $input = $element.find('input');
		/** @type {JQuery<HTMLFormElement>} */ // @ts-ignore
		const $form = $element.closest('form');
		const options = $element.data('mph') || {};
		let delay = Number(options.d || 0);
		// Delay might be in seconds
		delay = (delay > 1000) ? delay : (delay * 1000);
		// Add 1 second to the delay, to account for js loading time
		// ? Note: Not needed
		delay = (delay > 0) ? Number(delay/*  + estimatedFCP */) : 0;

		// console.debug('🔶 Setting mph for form (with delay: %o): %o', delay, $element[0], $input[0], $form[0]);

		// eslint-disable-next-line unicorn/consistent-function-scoping
		const clear = (type = '') => {
			const placeholder = $input.attr('placeholder');
			const value = $input.val();
			// Clear the value only if the placeholder is set and the value is the placeholder or empty
			if ((placeholder && (placeholder === value)) || !placeholder) {
				// console.debug('🔷 Clearing mph for form (event type: %o, placeholder: %o, value: %o, eq: %o): %o', type, placeholder, value, placeholder === value, $form[0]);
				$input.val('');
			}
			// else {
			// 	console.debug('🔴 Not clearing mph for form (event type: %o, placeholder: %o, value: %o, eq: %o): %o', type, placeholder, value, placeholder === value, $form[0]);
			// }
			$form.off('.mph');
		};

		$form.on('focusin.mph focusout.mph keydown.mph', (e) => {
			if (now() > delay) {
				clear(e.type);
			}
		});
	}
};